import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { LogOut, Terminal, ShieldCheck } from "lucide-react";
import { Wordmark } from "./Logo";
import { useAuth } from "../AuthContext";
import { useLang } from "../i18n";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const { t, lang, toggle } = useLang();
  const navigate = useNavigate();

  return (
    <motion.nav
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-[#1F2937]/60 bg-[#080A0C]/75 backdrop-blur-xl"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" className="hover:opacity-85 transition-opacity">
          <Wordmark size={34} />
        </Link>
        <div className="flex items-center gap-3 sm:gap-5">
          <a href="/#apps" data-testid="nav-apps-link" className="hidden sm:block font-mono text-xs tracking-wider text-gray-400 hover:text-[#00FF66] transition-colors">{t.navApps}</a>
          <a href="/#come-funziona" data-testid="nav-how-link" className="hidden sm:block font-mono text-xs tracking-wider text-gray-400 hover:text-[#00FF66] transition-colors">{t.navHow}</a>
          <button data-testid="lang-toggle-btn" onClick={toggle}
            className="font-mono text-xs tracking-widest px-3 py-1.5 rounded-full border border-[#1F2937] text-gray-300 hover:border-[#00FF66] hover:text-[#00FF66] transition-colors">
            {lang === "it" ? "EN" : "IT"}
          </button>
          {user ? (
            <>
              {user.role === "admin" && (
                <Link to="/admin" data-testid="nav-admin-link"
                  className="hidden sm:flex items-center gap-2 font-mono text-xs tracking-wider px-4 py-2 rounded-full border border-[#F59E0B]/40 text-[#F59E0B] hover:bg-[#F59E0B]/10 transition-colors">
                  <ShieldCheck size={13} /> {t.navAdmin}
                </Link>
              )}
              <Link
                to="/dashboard"
                data-testid="nav-dashboard-link"
                className="flex items-center gap-2 font-mono text-xs tracking-wider px-4 py-2 rounded-full border border-[#00FF66]/40 text-[#00FF66] hover:bg-[#00FF66]/10 transition-colors"
              >
                <Terminal size={13} /> {t.navDashboard}
              </Link>
              <button
                data-testid="nav-logout-btn"
                onClick={async () => { await logout(); navigate("/"); }}
                className="text-gray-500 hover:text-white transition-colors"
                title="Esci"
              >
                <LogOut size={16} />
              </button>
            </>
          ) : (
            <Link
              to="/auth"
              data-testid="nav-login-btn"
              className="font-mono text-xs tracking-wider px-5 py-2 rounded-full bg-[#00FF66] text-[#080A0C] font-bold hover:bg-[#5CFF9B] hover:shadow-[0_0_25px_rgba(0,255,102,0.45)] transition-all"
            >
              {t.navLogin}
            </Link>
          )}
        </div>
      </div>
    </motion.nav>
  );
};
